/* Ambient soundtrack: default on, with browser-safe autoplay fallback. */
(()=>{
 const button=document.querySelector('.alchemist-music-toggle');
 if(!button)return;
 const audio=document.createElement('audio');
 audio.src=button.dataset.src;
 audio.loop=true;
 audio.preload='auto';
 audio.volume=0.55296; // 20% louder than v2.26 (0.4608)
 audio.setAttribute('aria-hidden','true');
 document.body.appendChild(audio);
 const key='alchemist-ambient-preference-v2';
 const timeKey='alchemist-ambient-v2-time';
 const read=(k)=>{try{return localStorage.getItem(k)}catch(e){return null}};
 const write=(k,v)=>{try{localStorage.setItem(k,v)}catch(e){}};
 const readTime=()=>{try{return sessionStorage.getItem(timeKey)}catch(e){return null}};
 const writeTime=(v)=>{try{sessionStorage.setItem(timeKey,v)}catch(e){}};
 let wanted=read(key)!=='off';
 const setUI=(on)=>{
  button.setAttribute('aria-pressed',String(on));
  button.setAttribute('aria-label',on?'Turn atmospheric music off':'Turn atmospheric music on');
  button.title=on?'Turn atmospheric music off':'Turn atmospheric music on';
  const label=button.querySelector('.music-label');
  if(label)label.textContent=on?'Music On':'Music Off';
 };
 setUI(wanted);
 const position=Number(readTime());
 if(Number.isFinite(position)&&position>0){audio.addEventListener('loadedmetadata',()=>{if(Number.isFinite(audio.duration)&&audio.duration>0)audio.currentTime=position%audio.duration},{once:true})}
 const play=()=>{
  if(!wanted||!audio.paused)return;
  const attempt=audio.play();
  if(attempt&&typeof attempt.catch==='function')attempt.catch(()=>{/* Browser may require a gesture. */});
 };
 button.addEventListener('click',()=>{
  wanted=!wanted;
  write(key,wanted?'on':'off');
  setUI(wanted);
  if(wanted)play();else audio.pause();
 });
 audio.addEventListener('timeupdate',()=>{if(wanted)writeTime(String(audio.currentTime))});
 document.addEventListener('visibilitychange',()=>{if(document.hidden&&wanted)writeTime(String(audio.currentTime))});
 // Try immediately; browsers that prohibit audible autoplay will block this.
 if(wanted)play();
 // A user's first click, tap, or keypress can unlock playback if autoplay was blocked.
 const resume=()=>{if(wanted&&audio.paused)play()};
 document.addEventListener('pointerdown',resume);
 document.addEventListener('keydown',resume);
})();

